const getters = {
  walletAddress: state => state.wallet.walletAddress,
  connectWalletType: state => state.wallet.connectWalletType,
  isConnectWallet: state => state.wallet.isConnectWallet,
  currentNetworkID: state => state.wallet.currentNetworkID,
  net: state => state.wallet.net,
  gasPrice: state => state.wallet.gasPrice,
  slippage: state => state.wallet.slippage,
  deadline: state => state.wallet.deadline,
  multipath: state => state.wallet.multipath,
  transactions: state => state.wallet.transactions,
  block: state => state.wallet.block,
  screenWidth:state=>state.wallet.screenWidth,
}

export default getters;